import type { DataGridFilterState, DataGridSortingState } from '@ibsys/kit';
import type { PhraseListParams } from '@/entities/phrases';
import { PHRASE_COLUMNS, SORTABLE_PHRASE_COLUMNS } from './constants';

/** Границы отбора по продолжительности: пользователь задаёт их в секундах */
type SecondsRange = { from?: number; to?: number };

/** Границы отбора по времени обновления: ISO 8601 */
type TimestampRange = { from?: string; to?: string };

/** Продолжительность пользователь вводит в секундах, а контракт перечня считает её в миллисекундах */
const toMilliseconds = (seconds?: number): number | undefined =>
  seconds === undefined || Number.isNaN(seconds) ? undefined : Math.round(seconds * 1000);

/** Переводит окно, отбор и порядок таблицы в условия запроса перечня реплик. */
export const toPhraseListParams = (
  page: number,
  pageSize: number,
  sorting: DataGridSortingState,
  filters: DataGridFilterState,
): PhraseListParams => {
  const duration = filters[PHRASE_COLUMNS.duration] as SecondsRange | undefined;
  const updatedAt = filters[PHRASE_COLUMNS.updatedAt] as TimestampRange | undefined;
  const activeSort = sorting[0];
  const sortKey = activeSort ? SORTABLE_PHRASE_COLUMNS[activeSort.columnId] : undefined;

  return {
    limit: pageSize,
    offset: page * pageSize,
    sort: sortKey ? `${sortKey}:${activeSort.direction}` : undefined,
    durationFrom: toMilliseconds(duration?.from),
    durationTo: toMilliseconds(duration?.to),
    updatedAtFrom: updatedAt?.from || undefined,
    updatedAtTo: updatedAt?.to || undefined,
  };
};
